import type { CheckboxProps } from '../Checkbox/index.ts';
import type { VanillaLinkProps } from '../Link/index.ts';
import { createContext } from 'react';

export interface TableContextType {
  disabled?: boolean;
  renderLink?: (props: VanillaLinkProps) => React.ReactNode;
  selected?: CheckboxProps['checked'];
}

export const TableRowContext = createContext<TableContextType>({
  disabled: undefined,
  renderLink: undefined,
  selected: undefined
});
